import { render, staticRenderFns } from "./ItemMetaSelect.vue?vue&type=template&id=3f56d6c0&"
import script from "./ItemMetaSelect.vue?vue&type=script&lang=js&"
export * from "./ItemMetaSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports